<div class="content-container mat-elevation-z8">
  <h1 class="sso-domain-title">SSO Domain Management</h1>
  <p class="sso-domain-subtitle">View and create single sign-on domains</p>
  <div class="table-container">
    <div class="table-actions">
      <div class="search-bar-container">
        <mat-form-field class="search-form-field">
          <mat-label class="search-label"><mat-icon class="search-icon">search</mat-icon>Search</mat-label>
          <input matInput value="" (keyup)="applyFilter($event)" #input/>
          @if (input.value) {
            <button matSuffix mat-icon-button  (click)="removeSearch()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
      <button mat-fab extended class="add-domain-button" 
              matTooltip="Add new SSO domain"
              (click)="openAddDomainDialog()"
      ><mat-icon>add</mat-icon>Add New</button>
    </div>

    <table mat-table [dataSource]="dataSource" class="domain-table" matSort>

      <ng-container matColumnDef="ssoDomainValue" class="column-header-container">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-header">Domain</th>
        <td mat-cell *matCellDef="let element">{{element.ssoDomainValue}}</td>
      </ng-container>
      
      <ng-container matColumnDef="numberOfUsers" class="column-header-container">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-header">Number of Users</th>
        <td mat-cell *matCellDef="let element">{{element.numberOfUsers}}</td>
      </ng-container>

      <ng-container matColumnDef="Actions" class="-actions-column-header-container">
        <th mat-header-cell *matHeaderCellDef>
          <button mat-icon-button
                  matTooltip="Reload table"
                  (click)="reloadTable()"><mat-icon>refresh</mat-icon></button></th>
        <td mat-cell *matCellDef="let element">
          @if (element.numberOfUsers === 0) {
            <button mat-icon-button
                    class="edit-domain-button"
                    matTooltip="Edit domain"
                    (click)="openEditDomainDialog(element)">
              <mat-icon class="edit-domain-icon">edit</mat-icon>
            </button>
          }
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="domain-row"></tr>

        @if (loadingService.loading$ | async) {
          <tr class="domain-row" *matNoDataRow>
            <td class="mat-cell" colspan="3"><app-loading-spinner [strokeWidth]="5"></app-loading-spinner></td>
          </tr>
        }
  
        <tr class="domain-row" *matNoDataRow>
          <td class="mat-cell no-domains-found" colspan="3">No domains found</td>
        </tr>

  
    </table>
    <mat-paginator 
      [pageSizeOptions]="[10, 15, 20, 25, 50]" 
      showFirstLastButtons
      aria-label="Select page of domains" 
      class="table-paginator">
    </mat-paginator>
  </div>
</div>
